import React from 'react'
import { ImageGrid } from '@/components/ImageGrid'
import { IGlobalProps, IScene } from '@/types/cinematics'
import { isEmpty } from '@/utils/nunchee-kit/isEmpty'

interface ISponsorsProps {
  globalSponsorsProps?: IGlobalProps['sponsors']
  setSponsorsProps?: IScene['set']['sponsors']
}

export const Sponsors: React.FC<ISponsorsProps> = (props) => {
  const { globalSponsorsProps, setSponsorsProps } = props

  const sponsors = setSponsorsProps?.rows ? setSponsorsProps : globalSponsorsProps

  if (!sponsors || isEmpty(sponsors)) {
    return null
  }

  return <ImageGrid data={sponsors} />
}
